import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { AppConstants } from 'src/environments/constants';
import { Router } from '@angular/router';
import { TipologiaUtente } from 'src/app/model/utente/utente';
import { AuthService } from 'src/app/authentication/auth.service';
import { AppUtilsService } from 'src/app/shared/services/app-utils.service';
import { NotificheService } from 'src/app/services/notifiche/notifiche.service';
import { Notifica } from 'src/app/pages/notifiche/model/Notifica';
import { first as _first } from 'rxjs/operators';
import { CommonUtils } from 'src/utils/CommonUtils';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterViewInit {
  @Input() menuButtonVisible = true;
  @Input() role: TipologiaUtente;
  @Input() languageOptions: any;
  @Input() user: any;
  @Input() isAdmin;
  @Input() currLang: string = 'it';
  showToggle = false;
  isTeamView: boolean = false;
  fullname: string;
  langSelected: string;
  messageNotification: string;
  private notifiche: Notifica[] = [];

  @Output() menuClicked = new EventEmitter();
  @Output() translateSite = new EventEmitter();
  @ViewChild('notificationPanel') notificationPanel: ElementRef;
  myPanelData = [];

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly appUtils: AppUtilsService,
    private readonly notificheService: NotificheService,
    private readonly translateService: TranslateService,
  ) {}

  ngAfterViewInit(): void {
    this.observeAndRemoveKebab();
  }
  private observeAndRemoveKebab(): void {
    const panel = document.getElementById('notificationPanelId');
    if (!panel) return;

    const shadowPanel = panel.shadowRoot;
    if (!shadowPanel) return;

    const observer = new MutationObserver(() => {
      shadowPanel
        .querySelectorAll('ds-notification-panel-element')
        .forEach(el => {
          const shadowEl = (el as HTMLElement).shadowRoot;
          if (shadowEl) {
            shadowEl
              .querySelectorAll('ds-action-button')
              .forEach(btn => btn.remove());
          }
        });
    });

    observer.observe(shadowPanel, { childList: true, subtree: true });
  }

  ngOnInit(): void {
    this.showToggle =
      !!this.role &&
      (this.role === TipologiaUtente.ISPETTORE_ASSQUAL ||
        this.role === TipologiaUtente.RESPONSABILE_ASSQUAL);
    this.langSelected = 'it';
    this.fullname = this.user?.nome + ' ' + this.user?.cognome;
    this.recuperaNotifiche(true);
    setInterval(() => {
      this.recuperaNotifiche(true);
    }, 60000);
  }

  recuperaNotifiche(isNonLette: boolean): void {
    this.notificheService
      .getNotifiche(isNonLette)
      .pipe(_first())
      .subscribe(
        res => {
          if (res['errorMex'] == null) {
            this.notifiche = res['respObj'] || [];
            if (
              CommonUtils.isNotNullOrUndefined(this.notifiche) &&
              this.notifiche.length > 0
            ) {
              this.myPanelData = this.mapNotificheToMyPanelData(this.notifiche);
            } else {
              this.myPanelData = [];
            }
          } else {
            console.error('Get notifiche header ', res['errorMex']);
            this.notifiche = [];
            this.myPanelData = [];
          }
        },
        err => {
          console.error('Get notifiche header ', err);
          this.myPanelData = [];
        },
        () => {
          this.ariaLabelNotification(this.myPanelData.length);
        }
      );
  }

  mapNotificheToMyPanelData(notifiche: Notifica[]): any[] {
    return notifiche.map(notifica => {
      const dataCreazione = new Date(notifica.dataCreazione);
      const text =
        this.currLang === 'it' ? notifica.testoIta : notifica.testoEng;

      const title = this.translateService.instant(notifica.tipologiaNotifica);
      return {
        title: title,
        text: text || '',
        date: this.formatDate(dataCreazione),
        hour: this.formatHour(dataCreazione),
        read: notifica.isLetta,
        id: `notificationId${notifica.id}`,
        url: this.getUrlFromNotifica(notifica),
        isRouterLink: true,
        menuTitle: this.translateService.instant('NOTIFICATIONS.ACTIONS'),
        actions: [],
        warning: !notifica.isLetta,
      };
    });
  }

  getUrlFromNotifica(notifica: Notifica): string {
    if (notifica.idOrdine) {
      return `/${AppConstants.ORDINI_ROUTE}/${notifica.idOrdine}`;
    }
    if (notifica.idSvincolo) {
      return `/${AppConstants.SVINCOLI_ROUTE}/${notifica.idSvincolo}`;
    }
    if (notifica.idNonConformita) {
      return `/${AppConstants.NONCONFORMITA_ROUTE}/${notifica.idNonConformita}`;
    }
    if (notifica.idCollaudo) {
      return `/${AppConstants.ISPEZIONI_ROUTE}/${notifica.idCollaudo}`;
    }
    if (notifica.idDocumento) {
      return `/${AppConstants.DOCUMENTS_ROUTE}/${notifica.idDocumento}`;
    }
    return `/${AppConstants.NOTIFICHE_ROUTE}`;
  }

  formatDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  }

  formatHour(date: Date): string {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  menuClick() {
    this.menuClicked.emit();
  }

  logoutClick() {
    this.authService.logout();
  }

  changeLanguage(input) {
    this.translateSite.emit(input);
    this.langSelected = input;
    this.currLang = input;
    this.translateService.use(input).subscribe(() => {
      this.myPanelData = this.mapNotificheToMyPanelData(this.notifiche);
      this.updateProfileMenu();
    });
    this.ariaLabelNotification(this.myPanelData.length);
  }

  updateProfileMenu() {
    this.myProfileMenuItemsConfig = {
      ...this.myProfileMenuItemsConfig,
      items: this.myProfileMenuItemsConfig.items.map(item => ({
        ...item,
        isActive: item.id === this.langSelected,
        itemName:
          item.id === 'logoutButton'
            ? this.translateService.instant('logout')
            : item.itemName,
      })),
    };
  }

  ariaLabelNotification(number: number) {
    let key = 'noNotifications';

    if (number > 1) {
      key = 'numberNotifications';
    }
    if (number === 1) {
      key = 'numberNotification';
    }
    this.translateService.get(key, { number: number }).subscribe(message => {
      this.messageNotification = message;
    });
  }

  getLanguageClass(localization) {
    let langClass: string;

    if (localization == 'it') {
      langClass = 'flag-icon-it';
    } else {
      langClass = 'flag-icon-gb';
    }

    return langClass;
  }

  goToHomepage() {
    this.router.navigate([AppConstants.DASHBOARD_ROUTE]);
  }

  toggle(id: string) {
    const arrow = document.getElementById('arrowTopBar');
    const menu = document.getElementById(id);
    if (menu) {
      if (menu.classList.contains('hidden')) {
        menu.classList.remove('hidden');
        menu.style.display = 'flex';
        if (id === 'profileMenuId')
          arrow.setAttribute('icon', 'icon-chevron-up');
      } else {
        menu.classList.add('hidden');
        menu.style.display = 'none';
        if (id === 'profileMenuId')
          arrow.setAttribute('icon', 'icon-chevron-down');
      }
    }
  }

  onSwitchChange(e: CustomEvent) {
    if (e.detail.id === 'switchLeftId' && this.isTeamView) {
      this.isTeamView = false;
      alert('Switched to User View');
      this.appUtils.setIsTeamView(false);
    } else if (e.detail.id === 'switchRightId' && !this.isTeamView) {
      this.isTeamView = true;
      alert('Switched to Team View');
      this.appUtils.setIsTeamView(true);
    }
  }

  mySearchBoxData = {
    recentResultsHeader: 'Ricerche recenti',
    recentResultsLinkText: 'Vedi tutti i risultati',
    recentResultsLinkURL: 'javascript:void(0)',
    recentResultsLinkIsExternal: false,
    recentResultsLinkAriaLabel: 'aria label here',
    recentResults: [
      {
        text: 'Lorem Ipsum',
        url: 'javascript:void(0)',
        ariaLabel: 'aria text here',
        isExternal: false,
      },
      {
        text: 'Ipsum Lorem',
        url: 'javascript:void(0)',
        ariaLabel: 'aria text here',
        isExternal: false,
      },
      {
        text: 'Dolor sit amet',
        url: 'javascript:void(0)',
        ariaLabel: 'aria text here',
        isExternal: false,
      },
    ],
    otherResultsHeader: 'Altri risultati',
    otherResultsLinkText: 'Vedi tutti i risultati',
    otherResultsLinkURL: 'javascript:void(0)',
    otherResultsLinkIsExternal: false,
    otherResultsLinkAriaLabel: 'aria label here',
    otherResults: [
      {
        text: 'Ut enim ad lorem',
        url: 'javascript:void(0)',
        ariaLabel: 'aria text here',
        isExternal: false,
      },
      {
        text: 'Accusantium doloremque',
        url: 'javascript:void(0)',
        ariaLabel: 'aria text here',
        isExternal: false,
      },
    ],
    extraLinkText: 'Cerca Lorem in Documenti',
    extraLinkURL: 'javascript:void(0)',
    extraLinkIsExternal: false,
    extraLinkAriaLabel: 'aria label here',
  };

  myProfileMenuItemsConfig = {
    items: [
      {
        id: 'it',
        hasDispatchEvent: true,
        itemName: 'Italiano',
        isExternal: false,
        ariaLabel: 'aria label',
        isActive: true,
        icon: 'icon-flag-italy-colored',
      },
      {
        id: 'en',
        hasDispatchEvent: true,
        itemName: 'English',
        isExternal: false,
        ariaLabel: 'aria label',
        isActive: false,
        icon: 'icon-flag-uk-colored',
      },
      {
        id: 'logoutButton',
        hasDispatchEvent: true,
        itemName: 'Esci',
        isExternal: false,
        isLink: true,
        ariaLabel: 'aria label',
        isActive: false,
        hasTopDivider: true,
      },
    ],
  };

  onClickLanguages(e: CustomEvent) {
    if (e && (e.detail.id === 'it' || e.detail.id === 'en')) {
      this.myProfileMenuItemsConfig = {
        ...this.myProfileMenuItemsConfig,
        items: this.myProfileMenuItemsConfig.items.map(item => ({
          ...item,
          isActive: item.id === e.detail.id,
        })),
      };
      this.changeLanguage(e.detail.id);
    }
    if (e?.detail.id === 'logoutButton') {
      this.logoutClick();
    }
  }

  onShowAll(e: CustomEvent) {
    if (e.detail.url) this.router.navigate([e.detail.url]);
  }
}
